import { useSelector } from 'react-redux';
import { Icon, Txt } from '@vst/beam';
import { Message } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import {
  AnalyticsEventNames,
  Categories,
  DataLayerEventName,
  pushToAdobeDataLayer,
} from '@app/services/adobeDataLayer';
import { useDetectBrowser } from '@app/hooks';
import { selectLocale, selectUserInfo } from '@app/redux';
import { selectConfig } from '@app/redux/config';

import { Locale, Platform } from '@mfe/shared/schema-types';

import myversion from '../../../../../myversion.json';

import styles from './styles.module.scss';

const useFeedbackLink = (): string => {
  const { t } = useTranslation('Footer');
  const { userInfo } = useSelector(selectUserInfo);
  const { platform } = useSelector(selectConfig);
  const { locale } = useSelector(selectLocale);

  const PlatformLocale = () => {
    if (locale.userLocale === Locale.ItIt) return 'eu_web';
    return platform === Platform.Web ? 'web' : 'app';
  };

  const browser = useDetectBrowser();
  const url = t('feedbackLink', {
    context: PlatformLocale(),
    accountNumber: userInfo.accountNumber,
    browser,
    version: myversion.version,
  });
  return url;
};

export const FeedbackButton = () => {
  const { t } = useTranslation('Footer');
  const feedback = useFeedbackLink();

  const handleClick = (): void => {
    pushToAdobeDataLayer({
      event: DataLayerEventName.LINK,
      event_label: AnalyticsEventNames.FeedbackButton,
      event_category: Categories.Feedback,
    });
  };

  return (
    <a
      href={feedback}
      rel="noreferrer"
      target="_blank"
      data-cy="footer-feedback"
      className={styles['feedbackButton']}
      onClick={handleClick}
    >
      <Icon icon={Message} size={16} />
      <Txt variant="bodySmallRegular" component="p">
        {t('feedback')}
      </Txt>
    </a>
  );
};
